/** Tranche du donut : libelle, valeur (poids), couleur (token --chart-cat-*). */
export type DonutSlice = {
  label: string;
  value: number;
  color: string;
};

/** Couleur stable par index, cyclee sur les 8 tokens de categorie (index.css). */
export function chartCatColor(i: number): string {
  return `var(--chart-cat-${(i % 8) + 1})`;
}
